import { render, staticRenderFns } from "./modalReclamos.vue?vue&type=template&id=57ddafb0&scoped=true"
import script from "./modalReclamos.vue?vue&type=script&lang=js"
export * from "./modalReclamos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ddafb0",
  null
  
)

export default component.exports